import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StockLevelResponseDto } from "../../shared/dtos/stockLevel/StockLevelResponseDto";
import {
  getInitialListState,
  generateListReducers,
  ListState,
} from "../utils/listFactory";
import { ServerStatusPayload } from "../../shared/interfaces/ServerStatusPayload";

interface StockLevelState extends ListState<StockLevelResponseDto> {
  loadingAdjust: boolean;
  errorAdjust: string | null;
  serverStatus: ServerStatusPayload | null;
}

const initialState: StockLevelState = {
  ...getInitialListState<StockLevelResponseDto>(),
  loadingAdjust: false,
  errorAdjust: null,
  serverStatus: null,
};

export const stockLevelSlice = createSlice({
  name: "stockLevel",
  initialState,
  reducers: {
    ...generateListReducers<StockLevelResponseDto>(),
    setLoadingAdjust(state) {
      state.loadingAdjust = true;
      state.errorAdjust = null;
    },
    setErrorAdjust(state, action: PayloadAction<string | null>) {
      state.loadingAdjust = false;
      state.errorAdjust = action.payload;
    },
    adjustStockSuccess(state) {
      state.loadingAdjust = false;
      state.errorAdjust = null;
    },
    setServerStatus(state, action: PayloadAction<ServerStatusPayload | null>) {
      state.serverStatus = action.payload;
    },
  },
});

export const stockLevelActions = stockLevelSlice.actions;
export default stockLevelSlice.reducer;
